import Styles from './styles.module.css';
import SectionTitle from '../../home/_ui/sectionTitle';
import { IoHelpCircleOutline, IoCheckmarkCircleOutline } from 'react-icons/io5';

const Support = () => {
  return (
    <section className={Styles.support}>
      <SectionTitle
        pattern="B"
        title="学校だけに負担をかける仕組みではありません。"
      />

      <div className={Styles.body}>
        <div className={`${Styles.card} ${Styles.worry}`}>
          <span className={Styles.cardTag}><IoHelpCircleOutline />よくある不安</span>
          <p>
            「システムを入れたら、結局すべてのサロンに、学校から登録をお願いして回らないといけないのでは？」
          </p>
        </div>

        <div className={`${Styles.card} ${Styles.answer}`}>
          <span className={Styles.cardTag}><IoCheckmarkCircleOutline />memorii works の考え方</span>
          <p>
            {/* TODO: 断定表現（「行います」）にしてよいか要確認。現状はやや控えめな表現にしている。 */}
            memorii works 側からサロンへの登録案内や利用支援を行い、サロンが Web から求人票を提出できる環境づくりを進めます。学校側から全サロンへ依頼して回る必要はありません。
          </p>
        </div>
      </div>
    </section>
  );
};

export default Support;
